import { render } from "./TakeAwayPage.vue?vue&type=template&id=1bea613e"
import script from "./TakeAwayPage.vue?vue&type=script&lang=js"
export * from "./TakeAwayPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__